import React, { useState, useEffect, useRef } from 'react';

// Page 1 Component - intro
const Page1 = () => {
  return (
    <div className="flex w-full flex-col snap-start min-w-full h-full">
        <div className="relative z-10">
          <div className="about-blurb pt-4 p1 max-w-4xl opacity-0 animate-fade-in"
            style={{ animationDelay: '0.6s', animationFillMode: 'forwards' }}>
              <h2>A technical partner for founders and businesses</h2>
              <p>web design & development&nbsp;&nbsp;/&nbsp;&nbsp;custom app development&nbsp;&nbsp;/ &nbsp;&nbsp;technical consulting</p>
          </div>
        </div>
    </div>
  );
};

export default Page1;